export function returnUtm(link, campaign, source, medium, term, content) {
    return link + "?utm_campaign=" + campaign + "&utm_source=" + source + "&utm_medium=" + medium + "&utm_term=" + term + "&utm_content=" + content;
}
export function getProjectsByOwnerUrl(id, username) {
    return "/projects/team?ownerId=" + id + "&ownerUsername=" + username;
}
